<template>
  <div>
    <h1 v-if="loading" class="loader">
      <div class="spinner" title="2">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
  <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(160 25 25)">
    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
    </path>
  </svg>
      </div>
    </h1>
    <div v-if="!loading">
      <router-view :widget="widget"></router-view>
    </div>
    <div v-if="!loading">

      <link rel="stylesheet" type="text/css" :href="templateCssUrl">
    </div>
  </div>
</template>

<script>
  const API_URL = process.env.NODE_ENV === 'production'
    ? 'https://api.webservices.carbonwhite.se/api/public/widgets'
    : 'http://carbonwhite-api.test/api/public/widgets'

  const CSS_URL = process.env.NODE_ENV === 'production'
    ? '//v3.widgets.carbonwhite.se/css/templates/'
    : '//carbonwhite-widgets-vue.test/css/templates/'

  export default {
    name: 'Widget',
    data () {
      return {
        templateCssUrl: `${CSS_URL}${this.$route.params.template}.css`,
        loading: true,
        widget: null
      }
    },
    created () {
      this.init()
    },
    watch: {
      '$route.params.slug' (to, from) {
        this.init()
      }
    },
    methods: {
      init () {
        const slug = this.$route.params.slug
        this.load(slug)
      },
      transformData (json) {
        const rooms = json.objects.data.map(obj => obj.data['rooms']).filter((r) => r).sort()
        this.$store.commit('setRoomOptions', [...new Set(rooms)])
        this.$store.commit('setObjects', json.objects.data)
        this.$store.commit('setAvailableFilters', json.filters ? json.filters.data : [])
        this.$store.commit('setAvailableLighters', json.filters ? json.filters.data : [])
        this.loading = false
        return json
      },
      load (slug) {
        fetch(`${API_URL}/${slug}`)
          .then((response) => response.json())
          .then((json) => {
            this.widget = this.transformData(json)
            /*
            if (responseJson.sunstudies) {
              this.preloadSunstudies(responseJson.sunstudies.data).then(done => {
                this.setState({
                  data: responseJson
                })
              })
            }
            */
          })
      }
    }
  }
</script>

<style lang="scss">
  .spinner {
    text-align: center;
    top: 50%;
    position: absolute;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
    //margin-top: 50%;

    svg {
      width: 100px;
      height: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Widget.vue